<template>
  <div @validate="validate">
    <div class="columns">
      <div class="column is-three-fifths">
        <h3
        :style="{color: $store.getters.clientStyle.primary}"
        class="is-size-4 has-text-weight-bold">{{ question.name }}</h3>
      </div>
      <div class="column question-meta">
        <a v-if="crow || this.question.comment=='1'"
        class="button is-rounded comment-button"
        :class="{paddingRequiredQuestion: question.required==='1'}"
        @click="toggleComment()">
          <span class="icon comment-icon">
            <i class="fas fa-comment-alt"></i>
          </span>
          Opmerking
        </a>

        <span v-if="question.required==='1'" class="required-field" :class="{'required-field-green': question.valid, 'required-field-red': invalid}">
          verplicht</span>

        <span v-if="number > 0" class="counter">{{ number }}</span>
      </div>
    </div>

    <p class="question-description">{{ question.description }}</p>
    <!-- <p class="question-description">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> -->

  </div>
</template>

<script>
export default {
  data () {
    return {
      // invalid: false
      crow: false
    }
  },
  inject: ['question', 'comment', 'number', 'uploads'],
  methods: {
    validate () {
      this.invalid = !this.answered
    },
    toggleComment () {

      if ((this.question.comment_value === '') && this.comment.showComment) {
        this.comment.showComment = false
        // this.questionIsFocussed = true
      } else if (!this.comment.showComment) {
        this.comment.showComment = !this.comment.showComment
        this.comment.questionIsFocussed = true
      } else {
        this.comment.questionIsFocussed = !this.comment.questionIsFocussed
      }
    }
  },
  computed: {
    invalid () {
      if (this.$store.getters.getValidate) return !this.question.valid
      else return false
    }
  }
}
</script>

<style scoped>

  .question-description {
    margin-top: 10px;
  }

  .counter {
    font-weight: 700;
    font-size: 50px;
    color: #f1f1f1;
    line-height: 30px;
  }

  .question-meta {
    margin-top: 7px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .question-meta {
    margin-top: 7px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .required-field {
    position: absolute;
    margin-right: 60px;
    margin-left: -80px;
    margin-top: 2.5px;
    padding-top: 4px;
    padding-bottom: 4.5px;
    padding-right: 11px;
    font-size: 12px;
    color: #969696;
    background-color: transparent;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 20px;
    border: 2px solid #c3c3c3;
    /* color: #4a4a4a; */
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    /* height: 2em; */
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 1.5;
    padding-left: 0.75em;
    padding-right: 0.78em;
    white-space: nowrap;
    transition:
      border-color 300ms ease,
      color 300ms ease;
  }

  .required-field-red {
    color: #ff8989;
    /* background-color: #ffe0e0; */
    border: 2px solid #ff8989;
    transition:
      border-color 300ms ease,
      color 300ms ease;
  }

  .required-field-green {
    color: #02d259;
    /* background-color: #e0ffe7; */
    border: 2px solid #02d259;
    transition:
      border-color 300ms ease,
      color 300ms ease;
  }

  .required-field-grey {
    
  }

  .required-icon {
    margin-top: -3px;
    margin-bottom: -3px;
    margin-left: -5px;
  }

  .comment-button {
    background-color: #f1f1f1;
    color: #969696;
    font-size: 15px;
    border: none;
    margin-right: 20px;
    margin-top: 1px;
    padding-bottom: 6px;
    height: 32px;
    transition:
      background-color 300ms ease,
      color 300ms ease;
  }

  .comment-button:hover {
    background-color: #e0e0e0;
    color: #565656;
  }

  .comment-icon {
    padding-right: 22px;
    padding-left: 13px;
    margin-bottom: -3px;
  }

  .paddingRequiredQuestion {
    margin-right: 140px;
    /* margin-left: -150px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/QuestionHeader.vue